var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5680_6448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6121 3.88759C13.864 3.10867 11.9109 2.9157 10.0441 3.33747C8.17735 3.75925 6.49693 4.77316 5.25347 6.228C4.01002 7.68283 3.27016 9.50065 3.14424 11.4103C3.01832 13.32 3.51308 15.2192 4.55473 16.8247C5.59638 18.4303 7.12912 19.656 8.92434 20.3193C10.7196 20.9825 12.6811 21.0477 14.5164 20.5051C16.3517 19.9624 17.9624 18.8411 19.1083 17.3082C20.2541 15.7755 20.8738 13.9136 20.875 12C20.875 11.9998 20.875 12.0002 20.875 12M20.875 12V11.08C20.875 10.4587 21.3787 9.95499 22 9.95499C22.6213 9.95499 23.125 10.4587 23.125 11.08V12C23.1236 14.399 22.3468 16.734 20.9104 18.6554C19.474 20.5769 17.4549 21.9825 15.1543 22.6627C12.8538 23.3429 10.3949 23.2612 8.1446 22.4299C5.89424 21.5985 3.97293 20.0619 2.66719 18.0494C1.36146 16.0368 0.741268 13.6561 0.899115 11.2623C1.05696 8.86846 1.98439 6.58979 3.54309 4.76612C5.10178 2.94245 7.20822 1.67149 9.54826 1.14279C11.8883 0.614092 14.3365 0.85598 16.5279 1.83238C17.0954 2.08526 17.3505 2.75033 17.0976 3.31786C16.8447 3.88539 16.1797 4.14047 15.6121 3.88759",
    fill: "#739900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7951 3.20411C23.2347 3.64323 23.235 4.35554 22.7959 4.7951L12.7959 14.8051C12.585 15.0163 12.2987 15.1349 12.0003 15.135C11.7018 15.1351 11.4156 15.0165 11.2045 14.8055L8.2045 11.8055C7.76517 11.3662 7.76517 10.6538 8.2045 10.2145C8.64384 9.77517 9.35616 9.77517 9.7955 10.2145L11.9996 12.4186L21.2041 3.2049C21.6432 2.76534 22.3555 2.76499 22.7951 3.20411Z",
    fill: "#739900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5680_6448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e64f93425459fa6355232f41e8f38906.svg";
export { ForwardRef as ReactComponent };